export default "__VITE_ASSET__DS4zKiVO__"